import { createWorker, Worker } from 'tesseract.js';

let engine: Promise<Worker> | null = null;

function japaneseEngine(): Promise<Worker> {
  if (!engine) {
    engine = createWorker('jpn');
  }
  return engine;
}

function withTimeout<T>(promise: Promise<T>, ms: number): Promise<T> {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error('timeout')), ms);
    promise.then(
      (value) => {
        clearTimeout(timer);
        resolve(value);
      },
      (error) => {
        clearTimeout(timer);
        reject(error);
      },
    );
  });
}

/**
 * Read Japanese text from a page image in this browser.
 * The image is not sent to an OCR service.
 */
export async function readScanText(image: HTMLCanvasElement): Promise<string> {
  try {
    const worker = await withTimeout(japaneseEngine(), 90000);
    const result = await withTimeout(worker.recognize(image), 90000);
    return result.data.text ?? '';
  } catch {
    engine = null;
    return '';
  }
}
